const doc = [({"en":({"js":({"team_surveys":({"feedback_states":({"has_all":"Has all", "has_none":"Has none", "has_started":"Has started"})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;